module.exports = __webpack_public_path__ + "img/nip_logo.9e11d101.png";